var Handlebars = require('/builds/lp-digital/backbee/toolbar-legacy/node_modules/handlebars/runtime.js');
module.exports = (Handlebars['default'] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<li class=\"item\">\n    <span class=\"btn btn-default btn-block btn-toggle-action text-left\">\n        <span class=\"cloud-label\"></span>\n        <button type=\"button\" class=\"btn cloud-page-action remove\">"
    + container.escapeExpression((lookupProperty(helpers,"trans")||(depth0 && lookupProperty(depth0,"trans"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"remove",{"name":"trans","hash":{},"data":data,"loc":{"start":{"line":4,"column":67},"end":{"line":4,"column":87}}}))
    + " </button>\n    </span>\n</li>";
},"useData":true});